export enum UserTypeEnum {
    Rater = 4
}
